import { Dialog } from 'primereact/dialog'
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import LoadingIndicator from '../../LoadingIndicator'
import { resolveMissingHawb } from '../../../services/csnDashboardService'
import getPrincipal from '../../../utils/getPrincipal'
import getPLACIUser from '../../../utils/getPLACIUser'

const ResolveMissingHawbPopup = ({
    resolveMissingHawbPopup,
    setResolveMissingHawbPopup ,
    flightData,
    setShowLoader,
    setAlertMessage,
    setStatus,
}) => {
    const { t } = useTranslation(['labels'])
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        console.log('flightData', flightData);
    }, [flightData])


    const handleCancel = () => {
        setResolveMissingHawbPopup({
            isOpen: false,
            awbNumber: null
        })
    }

    const handleConfirm = async () => {

        try {
            setShowLoader(true)
            const principal = getPrincipal()
            const placiUser = getPLACIUser()

            const reqObj = {
                userId:  principal?.sub,
                userStation: placiUser?.stationCode ? placiUser?.stationCode : null,
                awbNumber: resolveMissingHawbPopup.awbNumber,
                flightId: flightData.flightId,
                userType: principal?.type,

            }
            console.log('reqObj', reqObj);
            const response = await resolveMissingHawb(reqObj)
            console.log('response', response);
            if (response && response.status === 200) {
                setAlertMessage(`Missing HAWB discrepancy successfully resolved for AWB ${resolveMissingHawbPopup.awbNumber}.`)
                setStatus(true)
            } else {
                setAlertMessage(`Missing HAWB discrepancy could not be resolved for AWB ${resolveMissingHawbPopup.awbNumber}, please retry. If problem persists, please contact IT support.`)
                setStatus(false)
            }
        } catch (error) {
            console.log(error)
            setAlertMessage(`Missing HAWB discrepancy could not be resolved for AWB${resolveMissingHawbPopup.awbNumber}, please retry. If problem persists, please contact IT support.`)
            setStatus(false)
        } finally {
            setShowLoader(false)
            setResolveMissingHawbPopup({
                isOpen: false,
                awbNumber: null
            })
            window.scrollTo(0, 0)
        }

    }

    const RenderFooter = () => {
        return (
            <div>
                <button icon='' className='primary-button' onClick={handleCancel} >
                    {t('COMMON.CANCEL')}
                </button>
                <button icon='' className='secondary-button' onClick={handleConfirm}>
                    {t('COMMON.OK')}
                </button>
            </div>
        )
    }

    return (
        <div className='cargo-portal-container dialog-container'>
            <div className='portal-dialog p-fluid'>
                <Dialog
                    footer={<RenderFooter />}
                    visible
                    modal
                    closable={true}
                    header=''
                    onHide={handleCancel}
                >
                    <h3 className='mt-1 mb-4'>Resolve Missing HAWB</h3>
                    <p className='mt-2'>
                        Do you want to resolve the 'Missing HAWB' discrepancy for the AWB- {resolveMissingHawbPopup.awbNumber}?
                    </p>
                </Dialog>
            </div>
            {isLoading && <LoadingIndicator />}
        </div>
    )
}

export default ResolveMissingHawbPopup
